import { render, staticRenderFns } from "./ContestQuesAns.vue?vue&type=template&id=061fd9ef&scoped=true&"
import script from "./ContestQuesAns.vue?vue&type=script&lang=js&"
export * from "./ContestQuesAns.vue?vue&type=script&lang=js&"
import style0 from "./ContestQuesAns.vue?vue&type=style&index=0&id=061fd9ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061fd9ef",
  null
  
)

export default component.exports